// Auto-generated by scripts/generate-registry.mjs from packages/modules/text_bead_50/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const text_bead_50: ModuleSchema = {
  "id": "text_bead_50",
  "uniqueId": "B3D_TB50X",
  "createdAt": "2026-10-14T13:09:04.477Z",
  "updatedAt": "2026-10-16T14:18:55.447Z",
  "label": "Text Bead 50",
  "description": "Fixed-number text bead template locked to 50, with an offset body, raised letters, and horizontal cord bores.",
  "category": "accessories",
  "tags": [
    "text",
    "bead",
    "cord",
    "customizable"
  ],
  "sliders": [
    {
      "key": "glyphHeight",
      "label": "Letter Height",
      "min": 10,
      "max": 40,
      "default": 20,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "overallLength",
      "label": "Overall Length",
      "min": 30,
      "max": 70,
      "default": 40,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1,
        2
      ]
    },
    {
      "key": "overallDepth",
      "label": "Total Bead Depth",
      "min": 8,
      "max": 40,
      "default": 10,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "outlineOffset",
      "label": "Outline Offset",
      "min": 1,
      "max": 5,
      "default": 1,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "connectBases",
      "label": "Connect Bases (0=Off, 1=On)",
      "min": 0,
      "max": 1,
      "default": 0,
      "step": 1,
      "unit": "",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "cordHoleDiameter",
      "label": "Cord Through-Hole Diameter (0=Off)",
      "min": 0,
      "max": 8,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "cordHoleYOffset",
      "label": "Cord Hole Vertical Position",
      "min": -5,
      "max": 5,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    }
  ],
  "selects": [],
  "textParams": [
    {
      "key": "text",
      "label": "Fixed Text",
      "default": "50",
      "kind": "text",
      "enabled": false,
      "visible": true
    },
    {
      "key": "fontStyle",
      "label": "Font Family",
      "default": "century",
      "kind": "font",
      "enabled": true,
      "visible": true
    }
  ],
  "colorConfigs": [
    {
      "key": "offset_body",
      "label": "Offset Bead Body",
      "default": "#DB2777",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "letter_face",
      "label": "Raised Letter Face",
      "default": "#FCE7F3",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "letter_bead",
      "label": "Custom Letter Bead",
      "name": "Custom Letter Bead",
      "color": "#DB2777",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "offset_body",
          "label": "Offset Bead Body",
          "name": "Offset Bead Body",
          "groupId": 0,
          "colorKey": "offset_body",
          "defaultColor": "#DB2777",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "letter_face",
          "label": "Raised Letter Face",
          "name": "Raised Letter Face",
          "groupId": 1,
          "colorKey": "letter_face",
          "defaultColor": "#FCE7F3",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Complete Letter Bead"
    },
    {
      "id": "0",
      "label": "Download STL - Bead Body"
    },
    {
      "id": "1",
      "label": "Download STL - Raised 50"
    },
    {
      "id": "2",
      "label": "Download STL - Anniversary Text"
    }
  ]
};
